import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-civiscafe',
  templateUrl: './civiscafe.component.html',
  styleUrls: ['./civiscafe.component.scss']
})
export class CiviscafeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
